module.exports = __webpack_public_path__ + "static/media/zoleWon_50000.934f5f2b.png";